import { Center, Flex, Grid } from "@chakra-ui/react";

import { AvailibilityIcon } from "../elements/AvailibilityIcon";
import { Collapsable } from "../elements/Collapsable";
import { getCremNormYear } from "../shared/utils/cremNormUtils";
import { CalculationModel } from "../clients/KompasApi";
import { TextPopover } from "./TextPopover";

type Props = {
  calculation: CalculationModel | undefined;
};

export function ResidenceGeneralBlock({ calculation }: Props) {
  return (
    <Collapsable title="Algemeen">
      <Flex flexDir="column" gap={2} mt={2}>
        <Grid justifyContent="space-between" templateColumns="2fr 1fr">
          <TextPopover trigger="De Standaard">
            De Standaard grenswaarde voor dit woningtype / Berekende netto
            warmtebehoefte (kWh/m<sup>2</sup>) van scenario.
          </TextPopover>
          <Center>
            <AvailibilityIcon
              available={
                calculation?.deStandaardExceedance
                  ? calculation?.deStandaardExceedance <= 0
                  : false
              }
            />
          </Center>
        </Grid>
        <Grid justifyContent="space-between" templateColumns="2fr 1fr">
          <TextPopover trigger="Gasloos ready">
            De woning wordt klaargemaakt voor een gasloze toekomst.
          </TextPopover>
          <Center>
            <AvailibilityIcon
              available={
                calculation
                  ? calculation.energyDemand <=
                    calculation.deStandaardThresholdValue
                  : false
              }
            />
          </Center>
        </Grid>
        <Grid justifyContent="space-between" templateColumns="2fr 1fr">
          <TextPopover popoverSize="md" trigger="CRREM norm referentiejaar">
            CRREM staat voor Carbon Risk Real Estate Monitor. Het is een
            initiatief dat gericht is op energiebesparingen in gebouwen om te
            voldoen aan de klimaatdoelstellingen van het Klimaatakkoord van
            Parijs. Deze norm is geadopteerd door grote vastgoedbeleggers. De
            normweergave omvat het ambitiejaar met daaronder de CO2-uitstoot per
            vierkante meter bruto vloeroppervlak (gbo)
          </TextPopover>
          <Center>
            {getCremNormYear(calculation?.yearlyCO2EmissionPerUsableArea)}
          </Center>
        </Grid>
      </Flex>
    </Collapsable>
  );
}
